import { FfsPartLevelEligibility } from 'features/indicationTriage/cards/ffsCalc/ffsResultPublish/ffsRegionClassificationSchema'
import {
  FfsLevel,
  FfsPart,
} from 'features/indicationTriage/cards/ffsCalc/ffsResultPublish/ffsTypes'

/**
 * The one place the two spellings of an FFS level meet.
 *
 * The eligibility matrix and `entryRouteToPartLevel` speak `'level1' | 'level2'`;
 * saved reports and `FfsLevel` speak `'1' | '2'`. The conversion was being
 * written inline wherever the two met — three copies across two modules, one of
 * them an ad-hoc inverse buried in a filter — which is exactly how the two
 * representations drift apart.
 */

/** The eligibility matrix's spelling of a level. */
export type PartLevelKey = 'level1' | 'level2'

export const toFfsLevel = (key: PartLevelKey): FfsLevel =>
  key === 'level1' ? '1' : '2'

export const toPartLevelKey = (level: FfsLevel): PartLevelKey =>
  level === '1' ? 'level1' : 'level2'

/**
 * Whether a component type may be assessed at this exact part+level.
 *
 * Wraps the index so callers never have to translate spellings themselves: a
 * stale Level 1 report on a B1/B2 region must be rejected, and that check should
 * read as a question about eligibility rather than about string shapes.
 */
export const isPartLevelEligible = (
  eligibility: FfsPartLevelEligibility,
  part: FfsPart,
  level: FfsLevel
): boolean => eligibility[part][toPartLevelKey(level)].eligible
